import { Box, type BoxProps, CircularProgress } from '@mui/material';

export const LoadingScreen = ({
  sx,
  size,
  ...other
}: BoxProps & { size?: number }) => {
  return (
    <Box
      className="LoadingScreen"
      sx={{
        px: 5,
        width: 1,
        flexGrow: 1,
        minHeight: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: other.position ?? 'absolute',
        ...sx,
      }}
      {...other}
    >
      <CircularProgress
        size={size ?? 36}
        sx={{
          width: 1,
          maxWidth: 120,
          '& > .MuiCircularProgress-svg': {
            color: (p) => p.palette.grey[400],
          },
        }}
        color="secondary"
      />
    </Box>
  );
};
